import { Button, Tooltip } from 'antd';
import React from 'react';
import { MdArrowBackIosNew } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';




const GoBack = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <Tooltip title={'Go back'} placement='rightBottom' >
      <Button type='link' color='yellow' onClick={goBack} size={'sm'} icon={<MdArrowBackIosNew />} />
    </Tooltip>
  )
}

export default GoBack;